import React from "react";
import Link from "next/link";

const NavbarLinks: React.FC = () => (
  <nav>
    <ul className="flex flex-col lg:flex-row lg:items-center font-inter font-medium gap-6 lg:gap-1 lg:px-7">
      <li className="lg:px-3">
        <Link
          href="/customers"
          className="text-sm whitespace-nowrap flex items-center p-1 text-light-body-text hover:text-black"
        >
          Customers
        </Link>
      </li>
      <li className="lg:px-3">
        <a
          href="/about-us"
          className="text-sm whitespace-nowrap flex items-center p-1 text-light-body-text hover:text-black"
        >
          About Us
        </a>
      </li>
      <li className="lg:px-3">
        <a
          href="/pricing"
          className="text-sm whitespace-nowrap flex items-center p-1 text-light-body-text hover:text-black"
        >
          Pricing
        </a>
      </li>
      <li className="lg:px-3">
        <a
          href="/use-cases"
          className="text-sm whitespace-nowrap flex items-center p-1 text-light-body-text hover:text-black"
        >
          Use cases
        </a>
      </li>
    </ul>
  </nav>
);

export default NavbarLinks;
